import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/(client)/supply-chain-mapping/(pages)/(list)/insights',
)({
  beforeLoad: ({ location }) => {
    if (
      location.pathname === '/supply-chain-mapping/insights' ||
      location.pathname === '/supply-chain-mapping/insights/'
    ) {
      throw redirect({
        to: '/supply-chain-mapping/insights/overview',
      });
    }
  },
});
